<template>
  <h1>Speaking</h1>
</template>

<script lang="ts">
export default {

}
</script>

<style>

</style>